enum UserTypes {
  TYPE_PM = 'pm',
  TYPE_USER = 'user',
  TYPE_INTERNAL = 'internal',
  TYPE_LINGUIST = 'linguist',
  TYPE_CUSTOMER = 'customer',
  TYPE_CUSTOMER_PRIVATE = 'customer-private',
  TYPE_CUSTOMER_BUSINESS = 'customer-business',
  TYPE_ADMIN = 'admin',
  TYPE_SUPER_ADMIN = 'super-admin',
  TYPE_API_USER = 'api'
}

export default UserTypes
